import React, { Component } from 'react';
import moment from 'moment';
import axios from 'axios';
import { Configurations } from '../../../Utils/Configurations';
import Geral from '../../../Utils/Geral';
import { RelatorioBSMaisLideres } from 'ebs-orders-reports-react-lib';
import ErrorModal from '../../../Components/ErrorModal/ErrorModal';

class BSMaisLeaders extends Component {
    constructor(props) {
        super(props);

        this.handleOrg = this.handleOrg.bind(this);
        this.tipoAssinatura = this.tipoAssinatura.bind(this);
        this.badgesImpressos = this.badgesImpressos.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);

        this.state = {
            listaLideres: [],
            isLoading: true,
            orgSelecionada: "",

            hasError: false,
            errorMessage: '',
        }

        this.Configurations = new Configurations();

    }

    handleError(err) { this.setState({ hasError: true, errorMessage: err.message }) }
    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    handleOrg(eValue) {
        this.setState({ isLoading: true, orgSelecionada: eValue, flagBusca: true },
            () => {
                axios.get(this.Configurations.apiBasePath + "/relatorios-lideres/assinatura-bs-mais?organizacao=" + (this.state.orgSelecionada), { noLoading: true }).then(response => {
                    const { lideres, resumo } = response.data,
                        { totalLideres, lideresAssinantes, naoAssinantes, conexao, naoConexao, somenteImpressos } = resumo;

                    this.setState({
                        listaLideres: lideres,
                        totalLideres: totalLideres,
                        assinantes: lideresAssinantes,
                        naoAssinantes: naoAssinantes,
                        conexao: conexao,
                        naoConexao: naoConexao,
                        somenteImpressos: somenteImpressos,
                    })
                }).catch(this.handleError).finally(() => {
                    this.setState({ isLoading: false })
                });
            }
        );
    }

    tipoAssinatura(tipo) {
        let _colorBadge, _textColor;
        const _tipo = tipo ? tipo : 'Sem assinatura'
        switch (_tipo.toLowerCase()) {
            case "individual":
                _colorBadge = 'verde';
                _textColor = 'white';
                break;
            case "familiar":
                _colorBadge = 'verde';
                _textColor = 'white';
                break;
            default:
                _colorBadge = 'secondary';
                break;
        }
        return <span className={`badge badge-tipo-assinatura badge-${_colorBadge} text-${_textColor}`}>{_tipo}</span>
    }

    badgesImpressos(arrayImpressos, ultimoImpresso, tipoAssinatura) {
        if (arrayImpressos.length === 0) {
            if (!tipoAssinatura && ultimoImpresso) {
                return <span>{moment(ultimoImpresso).format("DD/MM/YY")}*</span>
            } else if (!tipoAssinatura) return <span>Sem registro</span>
        } else return arrayImpressos.map((item, index) => {
            return <span key={index} className={`badge badge-impressos my-2 badge-${Geral.obtemTipoBadge(item).badgeColor} text-${Geral.obtemTipoBadge(item).textColorInside} mx-1`}>{item}</span>
        })
    }

    render() {
        const {
            totalLideres, assinantes, naoAssinantes, conexao, naoConexao, somenteImpressos, listaLideres,
            orgSelecionada, isLoading, flagBusca,
            hasError, errorMessage
        } = this.state;
        return (
            <React.Fragment>
                <RelatorioBSMaisLideres
                    totalLideres={totalLideres}
                    assinantes={assinantes}
                    naoAssinantes={naoAssinantes}
                    conexao={conexao}
                    naoConexao={naoConexao}
                    somenteImpressos={somenteImpressos}
                    listaLideres={listaLideres}
                    tipoAssinatura={this.tipoAssinatura}
                    badgesImpressos={this.badgesImpressos}
                    handleOrg={this.handleOrg}
                    orgSelecionada={orgSelecionada}
                    apiBasePath={this.Configurations.apiBasePath}
                    tokenKey={this.Configurations.tokenKey}
                    flagBusca={flagBusca}
                    isLoading={isLoading}
                />
                <ErrorModal isOpen={hasError} message={errorMessage} closeErrorModal={this.closeErrorModal} />
            </React.Fragment>

        )
    }
}
export default BSMaisLeaders;